module.exports = "<div style=\"padding:20px;text-align:center;\">\n<h4>Coming soon</h4>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/ultilities/setting/setting.component.html
// module id = ./src/app/ultilities/setting/setting.component.html
// module chunks = main